var initialWindowSafeAreaInsets=null;export default initialWindowSafeAreaInsets;
//# sourceMappingURL=InitialWindowSafeAreaInsets.web.js.map